import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, NavigationStart ,ActivatedRoute} from "@angular/router";
import {AssessmentService } from "../../services/assessment.service";

@Component({
  selector: 'app-authoring-assessment-view',
  templateUrl: './authoring-assessment-view.component.html',
  styleUrls: ['./authoring-assessment-view.component.scss']
})
export class AuthoringAssessmentViewComponent implements OnInit {

  assessmentDetails:any='';
  assessment_id:any='';
  capsuleId_id:any='';
  capsuleName:any='';
  backLink:any='';
  tab:any;adminData: any;
  constructor(private auth: AssessmentService,private router: Router,private route: ActivatedRoute) { }
  ngOnInit(): void {
    this.adminData = JSON.parse(localStorage.getItem('adminData') || '[]');
    this.capsuleName = localStorage.getItem('capsuleName');
    this.route.queryParams.subscribe(queryParams => {
    this.assessment_id = queryParams['id'];
    this.capsuleId_id = queryParams['capsuleId'];
    this.capsuleName = queryParams['capName'];
    this.tab = queryParams['tab'];
    this.backLink = queryParams['backLink'];
      this.assessmentDetail(this.assessment_id);
     });
  }
  logout(){
   // localStorage.clear();
    localStorage.removeItem('adminLoginPass');
 localStorage.removeItem('adminData');
    this.router.navigate(['./admin-login']);
   }
  assessmentDetail(id:any) {
    this.auth.assessmentDetail(id).subscribe(
      data=>{
        this.assessmentDetails = data.data;
        //console.log(data.data);
      },error=>{
        alert(error);
      }
    );
  }

}
